<div class="box" (mouseenter)="mouseIn=customer.idCustomer" (mouseleave)="mouseIn=null">
  <!-- <div class="logo-wrapper mb-3">
    <img [src]="'./assets/img/customers/' + customer.id +'.jpg'" class="logo">
  </div>
  <div class="title">
    {{customer.nome_cliente}}
  </div> -->


  <div class="customer-logo">
    <img [src]="'./assets/img/clienti/default.jpg'" class="logo" *ngIf="!customer.image">
    <img [src]="'./assets/img/clienti/' + customer.image" class="logo" *ngIf="customer.image">
  </div>
  <div class="customer-info" [ngClass]="{'customer-info-show': mouseIn==customer.idCustomer}">
    {{customer.description}}
  </div>
  

</div>